import React, { Component } from 'react';
import { Header } from 'marketing-components';
import getStore from '../../buttons/store/configureStore';
import _get from 'lodash/get';

const marketingHeaderContent = _get(getStore().getState(), 'application.marketingHeaderComponent.content');
const contentLoggedOut = _get(marketingHeaderContent, 'contentLoggedOut');
const contentLoggedIn = _get(marketingHeaderContent, 'contentLoggedIn');
const config = _get(marketingHeaderContent, 'config');

const content = contentLoggedOut;
const props = { content, config };

function MarketingHeader() {
	return <Header { ...props } />;
};

export default MarketingHeader;



// WEBPACK FOOTER //
// ./pages/marketingHeader/MarketingHeader.js